// extracted by mini-css-extract-plugin
export default {"card":"Card_card__STqLT","card_header":"Card_card_header__j+ifO","title":"Card_title__ZTGs5"};